"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesOrderStatisticsResponse = void 0;
const class_validator_1 = require("class-validator");
class SalesOrderStatisticsResponse {
}
__decorate([
    class_validator_1.IsInt()
], SalesOrderStatisticsResponse.prototype, "all", void 0);
__decorate([
    class_validator_1.IsInt()
], SalesOrderStatisticsResponse.prototype, "new", void 0);
__decorate([
    class_validator_1.IsInt()
], SalesOrderStatisticsResponse.prototype, "acknowledged", void 0);
__decorate([
    class_validator_1.IsInt()
], SalesOrderStatisticsResponse.prototype, "closed", void 0);
__decorate([
    class_validator_1.IsInt()
], SalesOrderStatisticsResponse.prototype, "deleted", void 0);
__decorate([
    class_validator_1.IsInt()
], SalesOrderStatisticsResponse.prototype, "duplicate", void 0);
__decorate([
    class_validator_1.IsInt()
], SalesOrderStatisticsResponse.prototype, "submitted", void 0);
__decorate([
    class_validator_1.IsInt()
], SalesOrderStatisticsResponse.prototype, "npi", void 0);
__decorate([
    class_validator_1.IsInt()
], SalesOrderStatisticsResponse.prototype, "production", void 0);
exports.SalesOrderStatisticsResponse = SalesOrderStatisticsResponse;
//# sourceMappingURL=sales-order-statistics.response.js.map